import React from 'react';
import { useRouter } from 'next/router';

import cx from 'classnames';
import { CanvasItem } from 'themes/canvas/components/Item/Item';

import { useServiceSelection } from 'hooks/page/services/useServiceSelection';
import { TServiceProps } from 'hooks/page/services/useServicesPage';

import { BuyNowPayLaterPromo } from 'routes/invoices/components/BuyNowPayLaterPromo/BuyNowPayLaterPromo';

import s from './CanvasService.module.css';

const CanvasService = ({
  service,
  listView = false,
  disabled = false,
  selected = false,
  serviceProvider,
  selectedOption,
  onClick,
}: TServiceProps) => {
  const {
    displayedPrice,
    toggleNoMatchingProvidersModal,
    onServiceClick,
    depositText,
    durationText,
    optionText,
    bnplUnitPrice,
    bnplCapabilities,
    renderNoMatchingProviderModal,
  } = useServiceSelection({
    service,
    selectedOption,
    disabled,
    onClick,
  });

  const router = useRouter();

  const { name, description, image } = service;

  const isHomePage = router.pathname === '/';

  const selectedText = selected ? 'Unselect' : isHomePage ? 'Book' : 'Select';

  let popovertarget;
  let popovertargetaction;

  const hasOptions = Boolean(service.options?.length);

  if (hasOptions && !selected) {
    popovertarget = 'service-option-modal';
  }
  if (hasOptions) {
    popovertargetaction = 'show';
  }

  return (
    <>
      {renderNoMatchingProviderModal()}
      <CanvasItem
        title={name}
        image={image}
        disabled={disabled}
        listView={listView}
        selected={selected}
        separator={selected && !!serviceProvider}
        button={
          <CanvasItem.Button
            onClick={onServiceClick}
            disabled={disabled}
            selected={selected}
            title={`${selectedText} ${name}`}
            type="button"
            name={selectedText}
            // eslint-disable-next-line react/no-unknown-property
            popovertarget={popovertarget}
            // eslint-disable-next-line react/no-unknown-property
            popovertargetaction={popovertargetaction}
          >
            <span className={s.buttonText}>{selectedText}</span>
          </CanvasItem.Button>
        }
      >
        {disabled && (
          <CanvasItem.Overlay onClick={toggleNoMatchingProvidersModal} />
        )}
        {selected && serviceProvider && (
          <p className={s.provider}>WITH {serviceProvider}</p>
        )}
        {depositText && <p className={s.deposit}>{depositText}</p>}
        {description && <p className={cx(s.summary)}>{description}</p>}
        <div className={s.details}>
          {optionText ? (
            <div data-testid="option" className={s.serviceOption}>
              {optionText}
            </div>
          ) : null}
          <span className={s.options}>
            <span className={s.option}>
              <b>Price:</b> {displayedPrice}
            </span>
            <span className={s.option}>
              <b>Duration:</b> {durationText}
            </span>
          </span>
        </div>
        {bnplUnitPrice ? (
          <div className={s.bnplEligible}>
            <BuyNowPayLaterPromo
              unitAmount={bnplUnitPrice}
              paymentMethodTypes={bnplCapabilities}
            />
          </div>
        ) : null}
      </CanvasItem>
    </>
  );
};

export { CanvasService };
